import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { Constant } from '../../../config/constant';
import { getErrorMessage } from '../../../api';
import { ListScheduleRequest, ListScheduleState } from '../../../types/schedule';
import { getDetailScheduleAPI, getListScheduleAPI } from '../../../api/schedules';
import { getOfficeAllProvinces } from '../../../api/offices';

// @ts-ignore
export const fetchListSchedule = createAsyncThunk(
  'admin/schedule',
  async (params: ListScheduleRequest, { dispatch, rejectWithValue }) => {
    try {
      const response = await getListScheduleAPI(params);
      const { data, status } = response;
      if (status === Constant.DEFAULT_STATUS) {
        dispatch(setListSchedule({ schedules: data.data, pagination: data.pagination, status: status }));
        return true;
      }
    } catch (error: any) {
      const { status } = error.response;
      dispatch(setListSchedule({ status: status }));
      return rejectWithValue(getErrorMessage(error));
    }
    return false;
  },
);
export const getDetailSchedule = createAsyncThunk(
  'admin/schedule-detail',
  async (id: number, { dispatch, rejectWithValue }) => {
    try {
      const response = await getDetailScheduleAPI(id);
      const { data, status } = response;
      if (status === Constant.DEFAULT_STATUS) {
        dispatch(setListScheduleDetail(data?.data));
        return true;
      }
    } catch (error: any) {
      const { status } = error.response;
      dispatch(setListScheduleDetail({ status: status }));
      return rejectWithValue(getErrorMessage(error));
    }
    return false;
  },
);

export const getAllProvinces = createAsyncThunk('admin/allProvinces', async (_, { dispatch, rejectWithValue }) => {
  try {
    const response = await getOfficeAllProvinces();
    const { data, status } = response;
    if (status === Constant.DEFAULT_STATUS) {
      dispatch(setListProvince(data?.data));
      return true;
    }
  } catch (error: any) {
    return rejectWithValue(getErrorMessage(error));
  }
  return false;
});
export const listScheduleSlice = createSlice({
  name: 'ListSchedule',
  initialState: {
    error: false,
    loading: false,
    loadingDetail: false,
    success: false,
    status: 0,
    schedules: [],
    listProvince: [],
    listSeatMap: [],
    listSegment: { segment: [] },
    listTransships: {},
    agent_seats: [],
    dataSchedule: {},
    fares: [],
    locks: [],
    isDetailSchedule: false,
    listScheduleDetail: [],
    isUpdatedSegment: false,
    isUpdateLocation: false,
    isUpdateSchedule: false,
    isUpdatedAgentSeat: false,
    isUpdatedPrice: false,
    idSeatMap: undefined,
    pagination: {
      total: 0,
      per_page: Constant.PAGE_SIZE,
      current_page: Constant.DEFAULT_PAGE,
      last_page: Constant.DEFAULT_PAGE,
    },
  } as ListScheduleState,
  reducers: {
    setListSchedule: (state: ListScheduleState, { payload }) => {
      const { schedules, pagination, status } = payload;
      state.schedules = schedules;
      state.pagination = pagination;
      state.status = status;
    },
    setListProvince: (state: ListScheduleState, { payload }) => {
      state.listProvince = payload;
    },
    resetListSchedule: (state: ListScheduleState) => {
      state.schedules = [];
      state.status = Constant.DEFAULT_STATUS;
    },
    setListSegment: (state: ListScheduleState, { payload }) => {
      state.listSegment = payload;
    },
    setListTransships: (state: ListScheduleState, { payload }) => {
      state.listTransships = payload;
    },
    resetListSegment: (state: ListScheduleState) => {
      state.listSegment = { segment: [] };
    },
    setListSeatMap: (state: ListScheduleState, { payload }) => {
      state.listSeatMap = payload;
    },
    setIdSeatMap: (state: ListScheduleState, { payload }) => {
      state.idSeatMap = payload;
    },
    setAgentSeat: (state: ListScheduleState, { payload }) => {
      state.agent_seats = payload;
    },
    setDataSchedule: (state: ListScheduleState, { payload }) => {
      state.dataSchedule = payload;
    },
    setListFare: (state: ListScheduleState, { payload }) => {
      state.fares = payload;
    },
    setListLock: (state: ListScheduleState, { payload }) => {
      state.locks = payload;
    },
    setListScheduleDetail: (state: ListScheduleState, { payload }) => {
      state.listScheduleDetail = payload;
    },
    setIsDetailSchedule: (state: ListScheduleState, { payload }) => {
      state.isDetailSchedule = payload;
    },
    setResetLoadSchedule: (state: ListScheduleState) => {
      state.fares = [];
      state.dataSchedule = {};
      state.listSegment = { segment: [] };
      state.listTransships = {};
      state.locks = [];
      state.agent_seats = [];
      state.isDetailSchedule = false;
      state.listSeatMap = [];
      state.listScheduleDetail = [];
      state.isUpdatedSegment = false;
      state.isUpdateLocation = false;
      state.isUpdateSchedule = false;
      state.isUpdatedAgentSeat = false;
      state.isUpdatedPrice = false;
      state.idSeatMap = undefined;
    },
    setUpdateSegment: (state: ListScheduleState, { payload }) => {
      state.isUpdatedSegment = payload;
    },
    setUpdateSchedule: (state: ListScheduleState, { payload }) => {
      state.isUpdateSchedule = payload;
    },
    setUpdateAgentSeat: (state: ListScheduleState, { payload }) => {
      state.isUpdatedAgentSeat = payload;
    },
    setUpdateLocation: (state: ListScheduleState, { payload }) => {
      state.isUpdateLocation = payload;
    },
    setUpdatePrice: (state: ListScheduleState, { payload }) => {
      state.isUpdatedPrice = payload;
    },
    setResetUpdateSetting: (state: ListScheduleState) => {
      state.isUpdatedSegment = false;
      state.isUpdateSchedule = false;
      state.isUpdatedAgentSeat = false;
      state.isUpdateLocation = false;
      state.isUpdatedPrice = false;
    },
    // setServices: (state: ListScheduleState, {payload}) => {
    //     const {service} = payload;
    //     let data: never[] = [];
    //     convertOption(data, service)
    //     state.ListSchedules = data;
    // },
    // setListScheduleLoad: (state: ListScheduleState) => {
    //     state.services = [];
    // },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchListSchedule.pending, (state: ListScheduleState) => {
      state.loading = true;
    });
    builder.addCase(fetchListSchedule.fulfilled, (state: ListScheduleState) => {
      state.loading = false;
      state.success = true;
      state.error = false;
    });
    builder.addCase(fetchListSchedule.rejected, (state: ListScheduleState) => {
      state.loadingDetail = false;
      state.success = false;
      state.error = true;
    });
    builder.addCase(getDetailSchedule.pending, (state: ListScheduleState) => {
      state.loadingDetail = true;
    });
    builder.addCase(getDetailSchedule.fulfilled, (state: ListScheduleState) => {
      state.loadingDetail = false;
      state.success = true;
      state.error = false;
    });
    builder.addCase(getDetailSchedule.rejected, (state: ListScheduleState) => {
      state.loadingDetail = false;
      state.success = false;
      state.error = true;
    });
  },
});

export const ListScheduleSelector = (state: RootState) => state.listSchedule;
export const {
  setListSchedule,
  setListProvince,
  setListSegment,
  resetListSegment,
  setListTransships,
  setListSeatMap,
  setAgentSeat,
  setDataSchedule,
  setListFare,
  setListScheduleDetail,
  setListLock,
  setResetLoadSchedule,
  setIsDetailSchedule,
  setUpdateAgentSeat,
  setUpdatePrice,
  setUpdateLocation,
  setUpdateSchedule,
  setUpdateSegment,
  setResetUpdateSetting,
  setIdSeatMap,
} = listScheduleSlice.actions;
